<div class="row">
  <div class="col-12 col-md-12">
    <section class="table_lis_data">
      <div id="header-detail" class="d-flex flex-row justify-content-between">
      </div>
      <div class="pt-1">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
          <app-custom-table [limitPaginator]="limitPaginator" [showRecover]="showRecover" [headers]="headers"
            [data]="data" [previousFilters]="filters" [isFilterPersistent]="isFilterPersistent"
            [showCheckbox]="showCheckbox" [actions]="actions" [isMultipleSelect]="isMultipleSelect"
            [selectAllByDefault]="selectAllByDefault" [filterPersistentKey]="filterPersistentKey"
            (onPageChange)="onPageChangeEmit($event)" (onFilterChange)="onFilterChangeEmit($event)"
            (onAction)="onAction($event)">
          </app-custom-table>
        </div>
      </div>
    </section>
  </div>
</div>

<app-custom-modal #showImages [label]="'Imágenes'" [header]="'Imágenes artículo'" [inputs$]="inputsForImagesSelect$"
  [output$]="output$" [children]="componentImage" [width]="'50%'" hidden>
</app-custom-modal>